var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"15px"}},[_vm._v("\n  托运人360\n")])}
var staticRenderFns = []

export { render, staticRenderFns }